import React, { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Loader from '../../../components/base/Loader/Loader';
import Grid from '../../../components/base/Grid/Grid';
import TabMenu from '../../../components/base/TabMenu/TabMenu';
import { userFIOFormatter, userPositionFormatter } from '../../../utils/formatters';
import Switches from '../../../components/fields/Switches/Switches';
import { getSettingsData } from '../reducer';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import SettingsDTO from '../../../dto/SettingsDTO';
import { copyTextToClipboard, responseLogWithNotification } from '../../../utils/utils';
import { loadSettingEnumLimited } from '../actions';

export default function SettingsPageView(props) {
  const {
    onHide,
    handleEdit = () => {},
  } = props;
  const namePrefix = 'scopes';
  const close = () => {
    onHide();
  };
  const dispatch = useDispatch();
  const [editNameDisabled, setEditNameDisabled] = useState(true);
  const [scopes, setScopes] = useState([]);

  const {
    setting,
    loadingSetting,
    loadingSettingEnum,
  } = useSelector(getSettingsData);

  const {
    control, getValues, setValue,
  } = useForm({
    defaultValues: {
      ...setting,
    },
  });

  const [selectedTab, setSelectedTab] = useState(setting?.is_test || false);

  const loadData = () => {
    dispatch(loadSettingEnumLimited()).catch(responseLogWithNotification).then(response => {
      const settingScopes = setting?.scopes || [];
      const allScopesEnum = response || [];
      const result = allScopesEnum.reduce((acc, item) => {
        acc[item.value] = settingScopes.includes(item.value);
        return acc;
      }, {}) || {};
      setValue(namePrefix, result);
      const scopesList = response?.map(item => ({ name: item.label, key: item.value, enable: scopes.includes(item.value) })) || [];
      setScopes(scopesList);
    });
  };

  useEffect(() => { loadData(); }, []);

  const columns = [
    {
      dataField: 'name',
      text: 'Передаваемая информация',
      headerClassName: 'name-column',
      disableSort: true,
    },
    {
      dataField: 'enable',
      text: 'Активен',
      disableSort: true,
      formatter: (_, item) => (
        <FieldDTOWithCol
          control={control}
          type="text"
          component={Switches}
          dtoObject={{
            name: `${namePrefix}.${item?.key}`,
            type: String,
            validators: {},
            labelKey: 'settings.key',
          }}
          variant="material"
          withLabel={false}
        />
      ),
    },
  ];

  const DTO = new SettingsDTO();
  const attributes = DTO.getAttributesByName();
  return ReactDOM.createPortal(
    <>
      <Loader loading={loadingSetting || loadingSettingEnum} />
      <div className="setting-view-page">
        <div className="setting-view-page-header">
          <div className="breadcrumbs">
            <span className="breadcrumbs-prev" onClick={close}> Настройка API</span>
            <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
            <span className="breadcrumbs-current"> {setting?.name || 'Нет названия'}</span>
          </div>
          <div className="close-button" onClick={close}>
            <Icons width={24} height={24} customIcon icon="close" />
          </div>
        </div>
        <div className="setting-view-wrapper">
          <div className="setting-box">
            <div className="setting-box-title">
              {setting?.name || 'Нет названия'}
            </div>
            <div className="setting-box-content">
              <div className="setting-box-field variant">
                <div className="setting-box-field-name">Активен:</div>
                <div className="setting-box-field-action-link">
                  <FieldDTOWithCol
                    control={control}
                    type="text"
                    component={Switches}
                    dtoObject={{
                      name: 'is_active',
                      type: Boolean,
                      validators: {},
                      labelKey: 'is_active',
                    }}
                    variant="material"
                    withLabel={false}
                  />
                </div>
              </div>
              <div className="setting-box-field">
                <div className="setting-box-field-name">Среда:</div>
                <div className="setting-box-field-action-link">
                  <TabMenu options={[{ value: true, label: 'Тестовая среда' }, { value: false, label: 'Продуктовая среда' }]} onSelectOptions={i => setSelectedTab(i.value)} selectedTab={selectedTab} />
                </div>
              </div>
              <div className="setting-box-field">
                <div className="setting-box-field-name">Название:</div>
                <Row className="row-cols-1">
                  <FieldDTOWithCol
                    control={control}
                    type="text"
                    component={TextInputWithLabel}
                    dtoObject={attributes.name}
                    label=""
                    variant="material"
                    disabled={editNameDisabled}
                  />
                </Row>
                { editNameDisabled
                  ? <div className="setting-box-field-action-link" onClick={() => setEditNameDisabled(false)}>Изменить</div>
                  : <div className="setting-box-field-action-link" onClick={() => { handleEdit(setting?.id, { name: getValues('name') }); setEditNameDisabled(true); }}>Сохранить</div>}
              </div>
              <div className="setting-box-field">
                <div className="setting-box-field-name">Автор:</div>
                <div className="setting-box-field-content">{userPositionFormatter({ full_name: userFIOFormatter(setting?.author) })}</div>
              </div>
              <div className="setting-box-field">
                <div className="setting-box-field-name">Точка подключения открытая:</div>
                <div className="setting-box-field-content link">
                  {setting?.endpoint || 'Нет информации'}
                </div>
                <div className="setting-box-field-action-link">Обновить</div>
              </div>
              <div className="setting-box-field">
                <div className="setting-box-field-name">Точка подключения закрытая:</div>
                <div className="setting-box-field-content link">
                  {setting?.endpoint || 'Нет информации'}
                </div>
                <div className="setting-box-field-action-link">Обновить</div>
              </div>
              <div className="setting-box-field-additional">
                <div className="setting-box-field">
                  <div className="setting-box-field-name">Параметры подключения:</div>
                  <div className="setting-box-field-action-link" onClick={() => copyTextToClipboard(JSON.stringify({ api_secret: setting?.api_secret }))}>Копировать</div>
                </div>
                <div className="setting-box-field-content">
                  api_secret: {setting?.api_secret || 'Нет информации'}
                </div>
              </div>
            </div>
          </div>
          <div className="setting-box">
            <div className="setting-box-title">Ограничения</div>
            <div className="setting-box-content">
              <div className="grid-wrapper">
                <Grid data={scopes || []} columns={columns} name="profile-list" />
              </div>
            </div>
            <div className="setting-box-footer">
              <Button onClick={() => handleEdit(setting?.id, { ...getValues(), is_test: selectedTab })}>Сохранить</Button>
            </div>
          </div>
        </div>
      </div>
    </>,
    document.getElementById('app-content'),
  );
}
